export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/CalculateRequestData.worker.c42d6377.worker.js");
}
